import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx";

interface MonthPickerMentorPayoutProps {
  month: number;
  setMonth: (month: number) => void;
  className?: string;
}

export const getCurrentMonthNumber = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth(); // 0-based (0 = January)
  
  const startYear = 2025;
  
  // If we're before 2025, default to January 2025 (month 0)
  if (currentYear < startYear) {
    return 0;
  }
  
  // Calculate sequential month number from January 2025
  const yearsDiff = currentYear - startYear;
  const totalMonths = (yearsDiff * 12) + currentMonth;
  
  return totalMonths;
};


const generateMentorPayoutMonths = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  const months = [];
  
  const startYear = 2025;
  const startMonth = 0; // January
  
  // Determine how many months to show:
  // - Always show all of 2025 (12 months)
  // - If current year > 2025, show months up to current month + 1 month ahead
  // - If current year = 2025, show months up to current month + 1 month ahead
  let endYear = Math.max(startYear, currentYear);
  let endMonth = 11; // December
  
  if (currentYear >= startYear) {
    // Show up to current month + 1 month ahead for future-proofing
    if (currentMonth < 11) {
      endMonth = currentMonth + 1;
    } else {
      // If it's December, show January of next year as well
      endYear = currentYear + 1;
      endMonth = 0;
    }
  }
  
  let monthCounter = 0;
  
  for (let year = startYear; year <= endYear; year++) {
    const startMonthForYear = year === startYear ? startMonth : 0;
    const endMonthForYear = year === endYear ? endMonth : 11;
    
    for (let month = startMonthForYear; month <= endMonthForYear; month++) {
      const monthDate = new Date(year, month, 1);
      const monthName = monthDate.toLocaleString("default", { month: "long" });
      
      months.push({
        name: `${monthName} ${year}`,
        number: monthCounter,
        actualMonth: month,
        actualYear: year
      });
      
      monthCounter++;
    }
  }
  
  return months;
};

export function MonthPickerMentorPayout({
  month,
  setMonth,
  className,
}: MonthPickerMentorPayoutProps) {
  const MONTHS = generateMentorPayoutMonths();
  
  return (
    <Select
      value={month.toString()}
      onValueChange={(month) => {
        setMonth(parseInt(month, 10));
      }}
    >
      <SelectTrigger className={`w-full ${className}`}>
        <SelectValue placeholder="Select Month" />
      </SelectTrigger>
      <SelectContent>
        {MONTHS.slice().reverse().map((m, i) => (
          <SelectItem key={i} value={"" + m.number}>
            {m.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
